import { PickerButtonVariant } from './picker-button.types'

export const getDisabledStatus = (
  value: PickerButtonVariant,
  name: PickerButtonVariant
) => Boolean(value !== name)
